var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isSvgIcon)?_c('SvgIcon',_vm._g(_vm._b({class:[_vm.$attrs.class],attrs:{"name":_vm.getSvgIcon,"size":_vm.size,"color":_vm.color}},'SvgIcon',_vm.$attrs,false),_vm.$listeners)):_c('span',_vm._g({class:[_vm.name ? `el-icon-${_vm.name}` : '', _vm.$attrs.class]},_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }